module.exports = __webpack_public_path__ + "img/evolve-level5-big.b6ecd1c1.png";